.header {
    background-color: var(--skeleton-grey);
    padding: 8px 16px;
}
